module.exports = __webpack_public_path__ + "img/icon-close.0d0fcb6d.svg";